import { Tags } from 'src/ts/enums/tags.enums';
import {
  caloriesPropertyAccessor,
  priceInCentsPropertyAccessor,
  proteinInGPropertyAccessor,
  recommenderScorePropertyAccessor,
  Sorter,
  tagSorter,
  totalCarbsInGPropertyAccessor,
} from 'src/utils/filters/sorters';

/**
 * Sorters that are used on the current Menu Page
 */
export const menuSorters: Sorter[] = [
  {
    displayName: 'Popular',
    sorters: [
      {
        defaultSorter: {
          direction: 'desc',
          propertyAccessor: recommenderScorePropertyAccessor,
        },
      },
    ],
  },
  {
    displayName: 'New and featured',
    sorters: [
      {
        customSorter: tagSorter,
        // @TODO: Use logical id
        additional: { tagId: Tags.NEW },
      },
    ],
  },
  {
    displayName: 'Price (low to high)',
    sorters: [
      {
        defaultSorter: {
          direction: 'asc',
          propertyAccessor: priceInCentsPropertyAccessor,
        },
      },
    ],
  },
  {
    displayName: 'Calories (low to high)',
    sorters: [
      {
        defaultSorter: {
          direction: 'asc',
          propertyAccessor: caloriesPropertyAccessor,
        },
      },
    ],
  },
  {
    displayName: 'Carbs (low to high)',
    sorters: [
      {
        defaultSorter: {
          direction: 'asc',
          propertyAccessor: totalCarbsInGPropertyAccessor,
        },
      },
    ],
  },
  {
    displayName: 'Protein (high to low)',
    sorters: [
      {
        defaultSorter: {
          direction: 'desc',
          propertyAccessor: proteinInGPropertyAccessor,
        },
      },
    ],
  },
];
